import { useEffect } from "react";

export function Seo({ title, description }) {
  useEffect(() => {
    if (title) document.title = `${title} | Domaleo Enterprise`;
    if (description) {
      let tag = document.querySelector('meta[name="description"]');
      if (tag) tag.setAttribute("content", description);
    }
  }, [title, description]);
  return null;
}
